import {
  ERROR_REQUIRED_FIELD,
  MIN_SIX_SYMBOLS,
  NO_SPACE,
  PATTERN_PASSWORD_VALIDATION_NO_SPACE,
} from '@app/constants';

export const RULES_IS_REQUIRE = [
  {
    required: true,
    message: <span data-testid="alert">{ERROR_REQUIRED_FIELD}</span>,
  },
];

export const PASSWORD_VALIDATION_RULES = [
  {
    pattern: PATTERN_PASSWORD_VALIDATION_NO_SPACE,
    message: <span data-testid="password-alert">{NO_SPACE}</span>,
  },
  {
    min: 6,
    message: <span data-testid="password-alert">{MIN_SIX_SYMBOLS}</span>,
  },
];

export const MAX_LENGTH_200_RULE = {
  max: 200,
  message: 'Максимальная длина 200 символов',
};

export const MAX_LENGTH_400_RULE = {
  max: 400,
  message: 'Максимальная длина 400 символов',
};
